import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("zor_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config.url.includes("/auth/login")) {
      localStorage.removeItem("zor_token");
      if (window.location.pathname !== "/giris") window.location.href = "/giris";
    }
    return Promise.reject(e);
  }
);

export const media = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u || "");

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d === "VERSION_CONFLICT") return "Metin bu arada değişti. Öneri güncel sürüme uygulanamaz.";
  if (!d) return e?.message || "Bir hata oluştu";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const timeAgo = (iso) => {
  if (!iso) return "";
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "az önce";
  if (s < 3600) return `${Math.floor(s / 60)} dakika önce`;
  if (s < 86400) return `${Math.floor(s / 3600)} saat önce`;
  return `${Math.floor(s / 86400)} gün önce`;
};

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "";
